import { useRetailVehicleAssignmentStore } from "@/stores/mulesoft-vehicle-data-Store";
import { useMdmClientHealthStore } from "@/stores/mdm-client-health-store";
import { useDraftResumeStore } from "@/stores/draft-resume-store";
import { useCurrentDraftStore } from "@/stores/selected-vehicle-store";

export function resetVehicleAssignmentStores() {
  useCurrentDraftStore.getState().setCurrentDraft(null);
  useRetailVehicleAssignmentStore.getState().setMuleSoftVehicleData(null);
  useMdmClientHealthStore.getState().clearMessage();
  useDraftResumeStore.getState().clearInconsistencies();
}
